import React, { Component } from 'react'
import { safeParse } from '../utils';
const Parser = safeParse;

class App extends Component {
  static defaultProps = {
    more: true
  }

  render() {
    const { 
      more
    } = this.props

    const data = this.props?.data || {}
    const block_obekti = data?.block_obekti || {}

    return (
      <div className='mt-[70px] xl:mt-[80px] tracking-[-0.04em] leading-none'>
        <div className='container'>
          <div className='flex items-center justify-center xl:justify-start gap-[10px] text-[14px] xl:text-[16px]'>
            <div className='inline-flex items-center px-[15px] h-[38px] bg-[#F5F7F9] rounded-full gap-[5px]'>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.37406 16.5003H3.05906C2.18906 16.5003 1.47656 15.8028 1.47656 14.9478V3.81776C1.47656 1.85276 2.93906 0.960262 4.73156 1.83776L8.06156 3.47276C8.78156 3.82526 9.37406 4.76276 9.37406 5.55776V16.5003Z" stroke="#032432" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M16.4775 11.2964V14.1314C16.4775 15.7514 15.7275 16.5014 14.1075 16.5014H9.375V7.81641L9.7275 7.89141L13.1025 8.64891L14.625 8.98641C15.615 9.20391 16.425 9.71391 16.47 11.1539C16.4775 11.1989 16.4775 11.2439 16.4775 11.2964Z" stroke="#032432" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M4.125 6.75H6.7275" stroke="#032432" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M4.125 9.75H6.7275" stroke="#032432" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M13.1016 8.64812V11.0631C13.1016 11.9931 12.3441 12.7506 11.4141 12.7506C10.4841 12.7506 9.72656 11.9931 9.72656 11.0631V7.89062L13.1016 8.64812Z" stroke="#032432" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M16.4691 11.1534C16.4241 12.0384 15.6891 12.7509 14.7891 12.7509C13.8591 12.7509 13.1016 11.9934 13.1016 11.0634V8.64844L14.6241 8.98594C15.6141 9.20344 16.4241 9.71344 16.4691 11.1534Z" stroke="#032432" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <div className='tracking-[-0.04em] text-[#032432]/60'>Объекты</div>
            </div>
          </div>
          <div className='flex flex-col xl:flex-row items-center xl:items-end justify-between gap-[20px]'>
            <h2 className='font-medium mt-[30px] text-[#032432] text-[24px] xl:text-[36px] text-center xl:text-start leading-none'>{Parser(block_obekti?.title)}</h2>
            {more &&
              <a href={block_obekti?.more} className='flex items-center gap-[9px] text-[14px] xl:text-[16px]'>
                <div className='text-[#032432]/60 whitespace-nowrap'>Смотреть все объекты</div>
                <svg width="5" height="12" viewBox="0 0 5 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.433105 0.25L3.60234 5.75L0.433105 11.25" stroke="#032432" stroke-opacity="0.6"/>
                </svg>
              </a>
            }
          </div>
          <div className='mt-[10px] text-[14px] xl:text-[16px] text-center xl:text-start text-black/60 tracking-[-0.02em]'>{Parser(block_obekti?.text)}</div>
          <div className='w-full overflow-x-auto pb-[10px] xl:pb-0 overflow-y-hidden'>
            <div className='mt-[20px] grid grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-[10px] leading-1 w-full'>
              {(block_obekti?.cards || []).map( ( elm ) => (
                <div className='w-full mb-[20px]'>
                  <img src={elm.image} alt={elm.name2} width={229} height={243} className='h-auto w-full max-w-[229px]' />
                  <div className='mt-[12px] xl:mt-[15px] text-[16px] xl:text-[18px] text-[#032432]'>{elm.name}<br /><span className='text-[#032432]/60'>{elm.name2}</span></div>
                </div>
              ) )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default App